import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-21/task-01";

const task: Slide = {
  title: "Which speech sound example has the lowest STI value?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
